import * as Yup from 'yup';

export const testEndListSchema = Yup.object({
  Description: Yup.string().required('Description is required'),
});
